var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teacher-student-detail"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("学生详情")]),_c('p',[_vm._v("学生ID: "+_vm._s(_vm.$route.params.id))]),_c('p',[_vm._v("学生详细信息页面，开发中...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }